require('./gameCardController');
require('../../schedule/scheduleGame/scheduleGameDirective');

"use strict";

angular.module('app.gamesOfTheWeek.gameCard.gameCardDirective', [
    'app.gamesOfTheWeek.gameCard.gameCardController',
    'app.schedule.scheduleGame.scheduleGameDirective'
])
.directive('gameCard', [
    function () {
        return {
            restrict: 'E',
            templateUrl: 'components/gamesOfTheWeek/gameCard/gameCardView.html',
            controller: 'app.gamesOfTheWeek.gameCard.gameCardController',
            scope: {
                game: '='
            }
        }
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/gamesOfTheWeek/gameCard/gameCardDirective.js